import { Control } from 'react-hook-form';
import { Checkbox } from '../../../../ui/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../ui/components/ui/form';
import { PRIVACY_POLICY_URL, TERMS_URL } from '../../constants/offer-checkout.constants';
import { OfferCheckoutFormValues } from '../offer-checkout-form/offer-checkout-form.schema';

const LINK_CLASS = 'underline underline-offset-2 hover:text-[#082729]';

const TermsCheckbox = ({ control }: { control: Control<OfferCheckoutFormValues> }) => (
  <FormField
    control={control}
    name="termsAccepted"
    render={({ field }) => (
      <FormItem>
        <div className="flex items-start gap-3">
          <FormControl>
            <Checkbox ref={field.ref} checked={field.value} onCheckedChange={(checked) => field.onChange(checked === true)} className="mt-0.5" />
          </FormControl>
          <FormLabel className="text-xs font-normal leading-relaxed text-[#082729]/50">
            Ich akzeptiere die{' '}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
              AGB
            </a>
            . Infos zum Datenschutz findest du in unserer{' '}
            <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
              Datenschutzerklärung
            </a>
            .
          </FormLabel>
        </div>
        <FormMessage />
      </FormItem>
    )}
  />
);

export default TermsCheckbox;
